var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXGrau(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.7 16.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#737373;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigationselemenete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_3",
    className: "cls-1",
    d: "M8.35,9.95L1.93,16.37c-.44,.44-1.16,.44-1.6,0h0c-.44-.44-.44-1.16,0-1.6l6.41-6.41L.33,1.93c-.44-.44-.44-1.16,0-1.6h0c.44-.44,1.16-.44,1.6,0l6.42,6.41L14.76,.33c.44-.44,1.16-.44,1.6,0h0c.44,.44,.44,1.16,0,1.6l-6.41,6.42,6.41,6.41c.44,.44,.44,1.16,0,1.6h0c-.44,.44-1.16,.44-1.6,0l-6.41-6.41Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXGrau);
export default __webpack_public_path__ + "static/media/X_grau.8c5a6a4829fb4927e4c3f76bd8fe8352.svg";
export { ForwardRef as ReactComponent };